
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/tv/[pageSection]",
      function () {
        return require("private-next-pages/m/tv/[pageSection]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/tv/[pageSection]"])
      });
    }
  